import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { UPLOAD_URL, BackendResponse } from '../models/constants';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UploadService {

  constructor(private http: HttpClient) { }

  uploadResource(resource: File): Observable<BackendResponse<string>> {
    return this.postFile<BackendResponse<string>>(resource, `${environment.coreServerUrl}${UPLOAD_URL}`);
  }

  private postFile<T>(fileToUpload: File, url: string): Observable<T> {
    const formData: FormData = new FormData();
    formData.append('file', fileToUpload, fileToUpload.name);
    return this.http.post<T>(url, formData, { withCredentials: true });
  }
}
